import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as analytics from '../utils/analytics';

/**
 * Custom hook for Google Analytics integration
 * 
 * This hook automatically tracks page views when the route changes
 * and provides access to all analytics tracking functions.
 */
export const useAnalytics = () => {
  const location = useLocation();

  // Track page views on route change
  useEffect(() => {
    analytics.trackPageView(location.pathname + location.search);
  }, [location]);

  return {
    trackEvent: analytics.trackEvent,
    trackSignUp: analytics.trackSignUp,
    trackLogin: analytics.trackLogin,
    trackVideoAnalysisStart: analytics.trackVideoAnalysisStart,
    trackVideoAnalysisComplete: analytics.trackVideoAnalysisComplete,
    trackRecommendationGenerated: analytics.trackRecommendationGenerated,
    trackCreditPurchase: analytics.trackCreditPurchase,
    trackExport: analytics.trackExport,
    trackShare: analytics.trackShare,
    trackNavigation: analytics.trackNavigation,
    trackError: analytics.trackError,
    setUserId: analytics.setUserId,
    setUserProperties: analytics.setUserProperties,
  };
};

export default useAnalytics;

